<template>
	<div class="predictiveSelect" :class="params.dependent">
		<input type="text"
			   :name="params.name"
			   :placeholder="params.placeholder"
			   v-model="inputText"
			   :dataValue="dataValue"
		>
		<ul class="predictiveSelect_list" v-show="Array.isArray(listFilter) && listFilter.length">
			<li
				v-for="(key, index) in listFilter"
				:key="key.id"
				:data-value="key.value"
				:data-name="key.name"
				@click="changeSelect"
				class="predictiveSelect_element"
			>
				{{ key.name }}
			</li>
		</ul>
	</div>
</template>

<script>
	/**
	 * инпут с предуктивным вводом
	 * при первом вводе пользователя отправляем запрос на сервер и показываем отфильтрованный список
	 * при нажатии пользователя на список отправляем новый запрос на сервер и после парсинга ответа
	 * тригерим событие с аргументами на зависемом инпуте
	 */
	exports.default = {
		name: 'preductiveSelect',
		props: ['dataParams'],
		data() {
			return {
				inputText: '',
				intervalGetData: '',
				responseList: [],
				params: {},
				clickEvent: false,
				dataValue: ''
			}
		},
		created() {
			let str = this.dataParams.replace(/'/g, '"');
			this.params =  JSON.parse(str);
			if(this.params.value !== undefined && this.params.value !== '') {
				this.inputText = this.params.value;
			}
		},
		mounted() {
			document.addEventListener('click', (e) => {
				// this.responseList = '';
				$('.predictiveSelect_list').css('display', 'none');
				if(	$(e.target).closest('.predictiveSelect').length &&
					$(e.target).closest('.predictiveSelect').find('.predictiveSelect_element').length) {

					$(e.target).closest('.predictiveSelect').find('.predictiveSelect_list').css('display', 'block');
					return;
				};
			}, true);

			$(this.$el).on('obey', (e, data) => {
				this.responseList = [];
				this.inputText = '';
				this.responseList = data.connect;
				// console.log(this.responseList);
			});
			$(this.$el).find('ul').perfectScrollbar();
		},
		watch: {
			inputText: function(text) {
				// console.log(this.listFilter);
				if(this.params.dependent){
					return;
				};
				if(this.params !== undefined && this.inputText === this.params.value){
					return;
				}
				// console.log(this.inputText);
				clearTimeout(this.intervalGetData);
				//ограничиваем количество запроссов
				this.intervalGetData = setTimeout(() => {
					if(!this.clickEvent) this.dataValue = '';

					let request = {
						[this.params.name]: {
							'text': this.inputText,
							'value': this.dataValue
						},
					}
					// test
					// let reqRes = {
					// 	"api_response" : {
					// 		"data": [
					// 			{
					// 				"name": "Киев",
					// 				"value": "123123123"
					// 			},
					// 			{
					// 				"name": "Львов1",
					// 				"value": "sdasdfgdgd"
					// 			},
					// 			{
					// 				"name": "Львов2",
					// 				"value": "sdasdfgdg"
					// 			},
					// 			{
					// 				"name": "Львов3",
					// 				"value": "sdasdfgd"
					// 			},
					// 			{
					// 				"name": "Львов4",
					// 				"value": "sdasdfg"
					// 			},
					// 			{
					// 				"name": "Львов5",
					// 				"value": "sdasdf"
					// 			}
					// 		],
					// 		"connect": [
					// 			{
					// 				"name": "Киев",
					// 				"value": "123123123"
					// 			},
					// 			{
					// 				"name": "Львов1",
					// 				"value": "sdasdfgdgd"
					// 			},
					// 			{
					// 				"name": "Львов2",
					// 				"value": "sdasdfgdg"
					// 			},
					// 			{
					// 				"name": "Львов3",
					// 				"value": "sdasdfgd"
					// 			},
					// 			{
					// 				"name": "Львов4",
					// 				"value": "sdasdfg"
					// 			},
					// 			{
					// 				"name": "Львов5",
					// 				"value": "sdasdf"
					// 			}
					// 		]
					// 	}
					// }
					// reqRes.test = request;

					if(this.clickEvent){
						this.clickEvent = false;
						request.connect = this.params.connect;
					}
					var options = {
						emulateJSON: true
					}
					this.$http.post(this.params.api, request, options)
						.then(
							(response) => {
								if(	response.body.api_response &&
									response.body.api_response.data) {
									this.responseList = response.body.api_response.data;
								}
								if (this.params.connect && response.body.api_response.connect) {
									$(this.params.connect).trigger('obey', response.body.api_response);
								} else {
									$(this.params.connect).trigger('obey', '');
								}
							},
							(err) => console.error(err)
						)
				}, 100);
			}
		},
		methods: {
			changeSelect(e) {
				this.clickEvent = true;
				this.inputText = e.target.getAttribute('data-name');
				this.dataValue = e.target.getAttribute('data-value');
				$(e.target).closest('.predictiveSelect_list').css('display', 'none');
			}
		},
		computed: {
			listFilter: {
				get: function () {

					if(this.inputText === '') return this.responseList;
					return this.responseList.filter(element => {
						return element.name.toLowerCase().startsWith(this.inputText.toLowerCase())
					});
				},
			}
		}
	}
</script>

<style lang="scss">
	.predictiveSelect{
		position: relative;
		display: inline-flex;
		input{
			height: 2.9375rem;
			padding: 0 25px;
			border-radius: 1.5rem;
			border: 1px solid #7E8183;
			margin-bottom: 0.9375rem;
		}
		.predictiveSelect_list{
			position: absolute;
			border: 1px solid #E2EDF3;
			border-radius: 8px;
			background-color: white;
			box-shadow: 2px 2px 5px #E2EDF3;
			max-height: 10.4375rem;
			width: 100%;
			top: calc(100% - 0.9375rem);
			overflow-y: auto;
			z-index: 2;
		}
		.predictiveSelect_element{
			font-size: 1rem;
			line-height: 1.5rem;
			padding: 5px 15px;
			color: #323232;
			&:hover{
				background-color: #E2EDF3;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// predictiveSelect.vue?5d0ec0d1